import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { Relatorio } from "@/types/relatorios/relatorio";

const nomesComParametrosAdicionais = [
  "DetalhesEmpenho",
  "DetalhesRestoPagar",
  "DotacaoOrcamentariaEmpenho",
];
export class RelatorioPCM extends ModelSagresDatatable {
  IdRelatorio: number;
  IdRelatorioNavigation: Relatorio;
  IdRelatorioPcm: number;
  IdSistema: number;
  IdSistemaNavigation: any;
  Obrigatorio: boolean;

  temParametrosAdicionais(): boolean {
    return (
      this.IdRelatorioNavigation &&
      nomesComParametrosAdicionais.includes(
        this.IdRelatorioNavigation.NomeRelatorio
      )
    );
  }
  empenhoComParametrosAdicionais(): boolean {
    return (
      this.IdRelatorioNavigation &&
      nomesComParametrosAdicionais
        .filter((x) => x.includes("Empenho"))
        .includes(this.IdRelatorioNavigation.NomeRelatorio)
    );
  }
}
